import {
  GoogleAuthProvider,
  OAuthProvider,
  signInWithPopup,
  type AuthProvider as FirebaseAuthProvider
} from 'firebase/auth';
import { getFirebaseAuth } from './firebase';
import type { AuthProvider } from '../types/entities';

export function buildAuthProvider(provider: AuthProvider): FirebaseAuthProvider {
  if (provider === 'google') return new GoogleAuthProvider();
  if (provider === 'apple') return new OAuthProvider('apple.com');

  throw new Error(`${provider} requires custom OAuth setup through Cloudflare Functions and Firebase custom tokens.`);
}

export async function signInWithSso(provider: AuthProvider) {
  const auth = getFirebaseAuth();
  const firebaseProvider = buildAuthProvider(provider);
  return signInWithPopup(auth, firebaseProvider);
}

export const customOAuthProviders: AuthProvider[] = ['kakao', 'naver'];
